export const defineCore = () => {
  Array.prototype.pluck = function(k) {
    return this.map(x => x[k])
  }

  Array.prototype.sum = function() {
    return this.reduce((r, x) => r + x, 0)
  }
}
